import React from 'react';
import { CustomerWork } from '../components/LearnEarn/CustomerWork';

const CustomerWorkPage = () => {
  return <CustomerWork />;
};

export default CustomerWorkPage;